import { Box, Button, Paper, Typography } from '@mui/material';
import lookupMain from 'assets/images/lookup-main.png';
import AuthContext from 'context/AuthContext';
import LookupCommon from 'pages/LookupCommonComponent/LookupCommon';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import classes from 'styles/globalStyle.module.scss';

import Loader from 'components/Loader/Loader';

import DistributorDataResult from './DistributorDataResult/DistributorDataResult';
import EquipmentAdjustment from './EquipmentAdjustment/EquipmentAdjustment';
import EquipmentAdjustmentNew from './EquipmentAdjustmentNew/EquipmentAdjustmentNew';

const LookupNew = () => {
  const location = useLocation();
  const { setShowMainPopup, pageData, showPage, setShowPage } = useContext(AuthContext);

  const { coApplicant, coSigner, reviewFlag, calculationState, completedSteps, viewAppFlow } =
    location?.state || {};

  const lookupSubmit = () => {
    setShowMainPopup(true);
  };

  return (
    <>
      {showPage === 'loader' && <Loader open={showPage === 'loader'} />}
      <LookupCommon completedSteps={completedSteps} viewAppFlow={viewAppFlow} />
      {!showPage && (
        <>
          <Typography variant="h3" component="h1">
            Lookup
          </Typography>
          <Paper className={classes.lookup} sx={{ marginTop: '20px' }}>
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              gap={2.5}
              width="50%"
            >
              <img src={lookupMain} width="442px" height="370px" />
              <Typography variant="h1" component="h3" textAlign="center">
                Buy smart, step by step <br />
                We will help you shop like a pro
              </Typography>
              <Typography variant="h5">
                Check out cars near you that could be the perfect match
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={lookupSubmit}
                id="start-lookup-btn"
                sx={{ marginBottom: '30px', marginTop: '30px' }}
              >
                Let&apos;s lookup
              </Button>
            </Box>
          </Paper>
        </>
      )}
      {showPage === 'distributorDataResult' && (
        <DistributorDataResult
          data={pageData?.data}
          valueGuide="Distributor Data"
          collateralType="new"
          setShowPage={setShowPage}
          coApplicant={coApplicant}
          coSigner={coSigner}
          reviewFlag={reviewFlag}
          calculationState={calculationState}
          completedSteps={completedSteps}
          viewAppFlow={viewAppFlow}
        />
      )}
      {showPage === 'equipmentAdjustment' && (
        <EquipmentAdjustment
          data={pageData?.data}
          productDetails={pageData?.productDetails}
          coApplicant={coApplicant}
          coSigner={coSigner}
          reviewFlag={reviewFlag}
          calculationState={calculationState}
          completedSteps={completedSteps}
          viewAppFlow={viewAppFlow}
        />
      )}
      {showPage === 'equipmentAdjustmentNew' && (
        <EquipmentAdjustmentNew
          options={pageData?.options}
          productDetails={pageData?.productDetails}
          msrp={pageData?.msrp}
          addDeductList={pageData?.addDeductList}
          invoice={pageData?.invoice}
          uvc={pageData?.uvc}
          uvcTieBreaker={pageData?.uvcTieBreaker}
          coApplicant={coApplicant}
          coSigner={coSigner}
          reviewFlag={reviewFlag}
          calculationState={calculationState}
          completedSteps={completedSteps}
          viewAppFlow={viewAppFlow}
        />
      )}
    </>
  );
};

export default LookupNew;
